<!-- 单图上传控件 -->
<template>
	<div class="single-upload">
		<el-upload class="avatar-uploader" :data="additionalData" :headers="headers" :action="uploadImgUrl" :before-upload="handleBeforeUpload" :on-success="handleUploadSuccess" :show-file-list="false">
			<img v-if="imageUrl" :src="imageUrl" :class="props.class" />
			<i v-else class="el-icon-plus avatar-uploader-icon"></i>
		</el-upload>
	</div>
</template>

<script setup>
import { getToken } from '@/utils/auth'
import { checkFileUpload } from '@/utils/scm'
import { useImageUrl } from '@/utils/dynamic'
import defaultSettings from '@/settings'
import defaultImgs from '@/images'

const emit = defineEmits(['update:modelValue'])

const props = defineProps({
	// 父组件 v-model 没有指定参数名，则默认是 modelValue
	modelValue: [String, Object, Array],
	// 大小限制(MB)
	fileSize: {
		type: Number,
		default: 5
	},
	// 文件类型, 例如['png', 'jpg', 'jpeg']
	fileType: {
		type: Array,
		default: () => ['png', 'jpg', 'jpeg', 'gif']
	},
	class: {
		type: String,
		default: 'avatar'
	}
})

const uploadImgUrl = ref(defaultSettings.fileUploadUrl) // 上传的图片服务器地址
const imageUrl = ref(defaultImgs.defaultImg)
const additionalData = ref({
	belongApp: defaultSettings.app,
	belongAppId: defaultSettings.appId
})

const headers = ref({ Authorization: 'Bearer ' + getToken() })

//使用 before-upload 限制用户上传的图片格式和大小
function handleBeforeUpload(file) {
	return checkFileUpload(file, props.fileType, props.fileSize)
}

//上传成功, 数据双向绑定
function handleUploadSuccess(res, file) {
	if (res && res.ResData) {
		imageUrl.value = res.ResData.FilePath
		emit('update:modelValue', imageUrl.value)
	} else {
		ElMessage.error(res.ErrMsg)
	}
}

// 因为props.modelValue是非引用类型，改变时，需要监听，对响应式数据重新赋值
watch(
	() => props.modelValue,
	(val) => {
		if (val != null && val != undefined && val != '') {
			//如果是远程文件则直接赋值
			imageUrl.value = useImageUrl(val)
		} else if (imageUrl.value != null && imageUrl.value != '') {
			emit('update:modelValue', imageUrl.value)
		}
	},
	{
		immediate: true,
		deep: true
	}
)
</script>

<style scoped lang="scss"></style>
